export default "__VITE_ASSET__R05QkNFm__"